"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENVIRONMENT_VARIABLES_TO_REQUIRED = exports.vizzlyToPossibleNativeDataTypes = exports.NATIVE_DATA_TYPES = exports.SUPPORTED_CLIENTS = void 0;
const lodash_1 = require("lodash");
const sqlbuilder_public_1 = require("@vizzly/sqlbuilder-public");
exports.SUPPORTED_CLIENTS = [
    'bigquery',
    'mariadb',
    'postgres',
    'snowflake',
    'mysql',
    'microsoftSQLServer',
    'redshift',
];
const buildDataTypeMapping = (client) => (0, lodash_1.reduce)(Object.keys(sqlbuilder_public_1.NATIVE_DATA_TYPES_DATABASE[client]), (acc, dT) => (Object.assign(Object.assign({}, acc), { [dT]: dT })), {});
exports.NATIVE_DATA_TYPES = {
    mysql: buildDataTypeMapping('mysql'),
    snowflake: buildDataTypeMapping('snowflake'),
    postgres: buildDataTypeMapping('postgres'),
    redshift: buildDataTypeMapping('redshift'),
    mariadb: buildDataTypeMapping('mariadb'),
    bigquery: buildDataTypeMapping('bigquery'),
    microsoftSQLServer: buildDataTypeMapping('microsoftSQLServer'),
};
const vizzlyToPossibleNativeDataTypes = (client, dataType) => {
    let nativeDataTypes = [];
    Object.entries(sqlbuilder_public_1.NATIVE_DATA_TYPES_DATABASE[client]).forEach(([nativeDataType, { normalizedType }]) => {
        if (normalizedType == dataType)
            nativeDataTypes = [...nativeDataTypes, nativeDataType];
    });
    return nativeDataTypes;
};
exports.vizzlyToPossibleNativeDataTypes = vizzlyToPossibleNativeDataTypes;
exports.ENVIRONMENT_VARIABLES_TO_REQUIRED = {
    postgres: {
        VIZZLY_POSTGRES_PASSWORD: true,
        VIZZLY_POSTGRES_DATABASE: true,
        VIZZLY_POSTGRES_USER: true,
        VIZZLY_POSTGRES_HOST: true,
        VIZZLY_POSTGRES_PORT: false,
    },
    mariadb: {
        VIZZLY_MARIADB_PASSWORD: true,
        VIZZLY_MARIADB_DATABASE: true,
        VIZZLY_MARIADB_USER: true,
        VIZZLY_MARIADB_HOST: true,
        VIZZLY_MARIADB_PORT: false,
    },
    mysql: {
        VIZZLY_MYSQL_PASSWORD: true,
        VIZZLY_MYSQL_DATABASE: true,
        VIZZLY_MYSQL_USER: true,
        VIZZLY_MYSQL_HOST: true,
        VIZZLY_MYSQL_PORT: false,
    },
    elasticsearch: {
        VIZZLY_ELASTICSEARCH_CLOUD_ID: true,
        VIZZLY_ELASTICSEARCH_API_KEY: true,
        VIZZLY_ELASTICSEARCH_NODE: true,
        VIZZLY_ELASTICSEARCH_USERNAME: true,
        VIZZLY_ELASTICSEARCH_PASSWORD: true,
        VIZZLY_ELASTICSEARCH_API_KEY_ID: true,
    },
    bigquery: {
        VIZZLY_BIGQUERY_PROJECT_ID: true,
        VIZZLY_BIGQUERY_REGION: true,
        VIZZLY_BIGQUERY_KEY_FILENAME: false,
        VIZZLY_BIGQUERY_CREDENTIALS: false,
    },
    snowflake: {
        VIZZLY_SNOWFLAKE_PASSWORD: true,
        VIZZLY_SNOWFLAKE_DATABASE: false,
        VIZZLY_SNOWFLAKE_USERNAME: true,
        VIZZLY_SNOWFLAKE_ACCOUNT: true,
        VIZZLY_SNOWFLAKE_WAREHOUSE: true,
        VIZZLY_SNOWFLAKE_ROLE: true,
        VIZZLY_SNOWFLAKE_SCHEMA: false,
        VIZZLY_SNOWFLAKE_SESSION_KEEP_ALIVE: false,
    },
    microsoftSQLServer: {
        VIZZLY_MICROSOFT_SQL_SERVER_PASSWORD: true,
        VIZZLY_MICROSOFT_SQL_SERVER_DATABASE: true,
        VIZZLY_MICROSOFT_SQL_SERVER_USER: true,
        VIZZLY_MICROSOFT_SQL_SERVER_HOST: true,
        VIZZLY_MICROSOFT_SQL_SERVER_PORT: false,
    },
};
